import { Box } from '@mui/material'
import NodeBox from './common/NodeBox'
import NodeSelect from './common/NodeSelect'
import End from '@assets/flowchart/End.svg'
import { useNodeData } from './common/useNodeData'

const severityOptions = [
  { id: '-10', label: 'נמוכה' },
  { id: '0', label: 'בינונית' },
  { id: '10', label: 'גבוהה' },
]

export default function EndNode({ id, data }: { id: string; data: any }) {
  const patch = useNodeData(id)
  return (
    <NodeBox title="סיומת" icon={End} nodeId={id} endsBranch>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <NodeSelect
          placeholder="חומרה"
          options={severityOptions}
          value={data?.severityId ?? '0'}
          onChangeValue={value => patch({ severityId: value })}
        />
      </Box>
    </NodeBox>
  )
}
